module.exports = __webpack_public_path__ + "img/27_35.1e49a946.png";